<template>
  <v-container mt-5>
      <v-row align="center" justify="center">
        <v-col cols="8" md="4">
            <v-text-field
              counter="4"
              :rules="rules"
              ref="flatId"
              v-model="flatId"
              class="text-input-black"
              label="Vyber číslo izby"
              @keyup.enter="confirmFladId">
            </v-text-field>
          </v-col>
          <v-col cols="1">
            <v-btn 
              color="accent" 
              @click="confirmFladId" 
              small 
              class="pa-0"
              >OK
            </v-btn>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "FlatId",
    props: [
        'block',
    ],
    data: () => ({
        flatId: null
    }),

     methods: {
      confirmFladId() {
        const regex = /^[0-9]{1,4}$/;
        if(this.flatId && regex.test(this.flatId)){
          this.$emit('change', this.flatId);
        }
      },
      validateInput() {
        this.formRef.validate()
      },
    },

    computed: {
      rules() {
        const rules = [];
        const regex = /^[0-9]+$/;
        const rule = v => (!!v && regex.test(v)) || "Povolene znaky: 0-9";
        const rule2 = v => (v !==null && v !== "") || "Toto pole musí byť vyplnené!";
        rules.push(rule2);
        rules.push(rule);//na poradi zalezi
        return rules
      }
    }
  }
</script>
